import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KeretService } from '../../keret.service';
import { modeNev, modeFavicon } from '../../mode-nevek';
import { EszkozAktiv, EszkozService } from '../eszkoz.service';

/*  TÁRGYI ESZKÖZ – a modul kerete. Fókusz témában a NAPLO/BÉR fejlécének párja (sötét sáv, a
 *  modul ikonja, fülek, jobbra az ügyfél + év és a profil), Klasszikusban egyszerű eszköztár (a
 *  menüt a bal sáv adja). Az ügyfél a NAPLO ügyféltörzséből választható – közös adat. */
@Component({
  selector: 'app-eszkoz-layout',
  templateUrl: './eszkoz-layout.component.html',
  styleUrls: ['./eszkoz-layout.component.scss'],
})
export class EszkozLayoutComponent implements OnInit, OnDestroy {
  alrendszerNev = modeNev('ESZKOZ');
  modIkon = modeFavicon('ESZKOZ');
  aktiv: EszkozAktiv = { intezmeny: '', ugyfelId: null, ugyfelNev: null, ev: new Date().getFullYear(), konyveles_mod: 'egyszeres' };
  readonly fulek = [
    { ut: '/eszkoz/eszkozok', cim: 'Eszközök', ikon: 'construct-outline' },
    { ut: '/eszkoz/ecs', cim: 'Értékcsökkenés', ikon: 'trending-down-outline' },
    { ut: '/eszkoz/megterules', cim: 'Megtérülés', ikon: 'cash-outline' },
    { ut: '/eszkoz/beallitasok', cim: 'Beállítások', ikon: 'settings-outline' },
  ];
  aktivUt = '';
  evek: number[] = [];

  /* ügyfélválasztó */
  valasztoNyitva = false;
  ugyfelek: any[] = [];
  kereso = '';

  private sub?: Subscription;
  private navSub?: Subscription;
  constructor(public router: Router, private eszkoz: EszkozService, private keret: KeretService) {}

  get fokusz(): boolean { return this.keret.a?.tema() === 'fokusz'; }

  async ngOnInit() {
    await this.eszkoz.init();
    await this.eszkoz.kozosAtvesz();
    this.sub = this.eszkoz.aktiv$.subscribe((a) => (this.aktiv = a));
    const most = new Date().getFullYear();
    this.evek = [most + 1, most, most - 1, most - 2, most - 3];
    this.utFrissit();
    this.navSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => this.utFrissit());
    document.body.classList.add('eszkoz-aktiv');       // a modálok témája (global.scss)
    if (!this.aktiv.ugyfelId) this.valasztoNyit();
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.navSub?.unsubscribe(); document.body.classList.remove('eszkoz-aktiv'); }
  private utFrissit() { this.aktivUt = this.router.url.split('?')[0]; }

  /*  Az ügyfélválasztó saját oldal (components/modul-ugyfelek): csempe / lista, keresés, önálló
   *  módban új ügyfél is – a modul ügyfélkör-módja szerint (backend/ugyfeltorzs.js). */
  valasztoNyit() { if (!this.router.url.startsWith('/eszkoz/ugyfelek')) this.router.navigateByUrl('/eszkoz/ugyfelek'); }

  get lathatoUgyfelek(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.ugyfelek.filter((u) => String(u.nev || '').toLowerCase().includes(k) || String(u.adoszam || '').includes(k)) : this.ugyfelek;
  }
  async ugyfelValaszt(u: any) {
    this.valasztoNyitva = false;
    await this.eszkoz.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, konyveles_mod: u.konyveles_mod || 'egyszeres' });
  }
  async evValt(ev: number) { await this.eszkoz.setAktiv({ ev: Number(ev) }); }
  open(url: string) { this.router.navigateByUrl(url); }
}
